import ProjectMoreButtonComponent from './ProjectMoreButton.vue'
import ChartOrdersComponent from './ChartOrders.vue'
import ChartMissingWarehouseItemsComponent from './ChartMissingWarehouseItems.vue'
import ChartMissingStorefrontItemsComponent from './ChartMissingStorefrontItems.vue'
import ChartReShipPercentComponent from './ChartReShipPercent.vue'
import ChartOrderReturnsMostSkuComponent from './ChartOrderReturnsMostSku.vue'
import ChartMostSoldProductsComponent from './ChartMostSoldProducts.vue'
import ChartMostLoyalCustomersComponent from './ChartMostLoyalCustomers.vue'

import ChartInventoryStatusCardsComponent from './ChartInventoryStatusCards.vue'
import ChartPOToReviewComponent from './ChartPOToReview.vue'
import DashAlertsAndMoreComponent from './DashAlertsAndMore.vue'
import ChartStorefrontByOrderStatusCountsComponent from './ChartStorefrontByOrderStatusCounts.vue'
import ChartOnHoldReasonPercentComponent from './ChartOnHoldReasonPercent.vue'
import ChartExpiresSoonWarehouseItemsComponent from './ChartExpiresSoonWarehouseItems.vue'
import WarehouseItemManageWidgetsComponent from './WarehouseItemManageWidgets.vue'
import InventoryStatusBadgeComponent from '../InventoryStatusBadge.vue'

import WidgetBulkPendingApprovalComponent from './WidgetBulkPendingApproval.vue'
import WidgetBulkStillToShipComponent from './WidgetBulkStillToShip.vue'
import WidgetSmallParcelStillToShipComponent from './WidgetSmallParcelStillToShip.vue'
import WidgetSmallParcelPendingApprovalComponent from './WidgetSmallParcelPendingApproval.vue'
import WidgetWTsStillToShipComponent from './WidgetWTsStillToShip.vue'
import WidgetWTsApprovalComponent from './WidgetWTsApproval.vue'
import ExpiringInventoryComponent from './ExpiringInventory.vue'

export const WidgetBulkPendingApproval = WidgetBulkPendingApprovalComponent
export const WidgetBulkStillToShip = WidgetBulkStillToShipComponent
export const WidgetSmallParcelStillToShip = WidgetSmallParcelStillToShipComponent
export const WidgetSmallParcelPendingApproval = WidgetSmallParcelPendingApprovalComponent
export const WidgetWTsStillToShip = WidgetWTsStillToShipComponent
export const WidgetWTsApproval = WidgetWTsApprovalComponent

export const InventoryStatusBadge = InventoryStatusBadgeComponent

export const WarehouseItemManageWidgets = WarehouseItemManageWidgetsComponent
export const ChartExpiresSoonWarehouseItems = ChartExpiresSoonWarehouseItemsComponent
export const ChartOnHoldReasonPercent = ChartOnHoldReasonPercentComponent
export const ChartStorefrontByOrderStatusCounts = ChartStorefrontByOrderStatusCountsComponent
export const ChartInventoryStatusCards = ChartInventoryStatusCardsComponent
export const ChartPOToReview = ChartPOToReviewComponent
export const DashAlertsAndMore = DashAlertsAndMoreComponent

export const ChartMostLoyalCustomers = ChartMostLoyalCustomersComponent
export const ChartMostSoldProducts = ChartMostSoldProductsComponent
export const ChartOrderReturnsMostSku = ChartOrderReturnsMostSkuComponent
export const ChartReShipPercent = ChartReShipPercentComponent
export const ChartMissingStorefrontItems = ChartMissingStorefrontItemsComponent
export const ChartMissingWarehouseItems = ChartMissingWarehouseItemsComponent
export const ChartOrders = ChartOrdersComponent
export const ProjectMoreButton = ProjectMoreButtonComponent
export const ExpiringInventory = ExpiringInventoryComponent
export default {
  ExpiringInventory: ExpiringInventoryComponent,
  InventoryStatusBadge: InventoryStatusBadgeComponent,
  WarehouseItemManageWidgets: WarehouseItemManageWidgetsComponent,
  ChartExpiresSoonWarehouseItems: ChartExpiresSoonWarehouseItemsComponent,
  ChartOnHoldReasonPercent: ChartOnHoldReasonPercentComponent,
  ChartStorefrontByOrderStatusCounts: ChartStorefrontByOrderStatusCountsComponent,
  ChartInventoryStatusCards: ChartPOToReviewComponent,
  ChartPOToReview: ChartPOToReviewComponent,
  DashAlertsAndMore: DashAlertsAndMoreComponent,
  ChartMostLoyalCustomers: ChartMostLoyalCustomersComponent,
  ChartMostSoldProducts: ChartMostSoldProductsComponent,
  ChartOrderReturnsMostSku: ChartOrderReturnsMostSkuComponent,
  ChartReShipPercent: ChartReShipPercentComponent,
  ChartMissingStorefrontItems: ChartMissingStorefrontItemsComponent,
  ChartMissingWarehouseItems: ChartMissingWarehouseItemsComponent,
  ChartOrders: ChartOrdersComponent,
  ProjectMoreButton: ProjectMoreButtonComponent,

  WidgetBulkPendingApproval: WidgetBulkPendingApprovalComponent,
  WidgetBulkStillToShip: WidgetBulkStillToShipComponent,
  WidgetSmallParcelPendingApproval: WidgetSmallParcelPendingApprovalComponent,
  WidgetSmallParcelStillToShip: WidgetSmallParcelStillToShipComponent,
  WidgetWTsStillToShip: WidgetWTsStillToShipComponent,
  WidgetWTsApproval: WidgetWTsApprovalComponent,
}
